import { render, staticRenderFns } from "./ThematicQualifications.vue?vue&type=template&id=1864ed52&scoped=true&"
import script from "./ThematicQualifications.vue?vue&type=script&lang=js&"
export * from "./ThematicQualifications.vue?vue&type=script&lang=js&"
import style0 from "./ThematicQualifications.vue?vue&type=style&index=0&id=1864ed52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864ed52",
  null
  
)

export default component.exports